import app from 'flarum/common/app';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import Stream from 'flarum/common/utils/Stream';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
export default class NewsWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.newslines = app.forum.attribute('fof-news-widget.lines');
    this.line = Stream({
      index: 0,
      text: this.newslines[0]
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (this.newslines.length > 1) {
      this.rotation = setInterval(() => {
        const newLineIndex = (this.line().index + 1) % this.newslines.length;
        this.line({
          index: newLineIndex,
          text: this.newslines[newLineIndex]
        });
        m.redraw();
      }, 7000);
    }
  }
  onremove(vnode) {
    super.onremove(vnode);
    clearInterval(this.rotation);
  }
  className() {
    return 'FoF-NewsWidget';
  }
  icon() {
    return 'fas fa-bullhorn';
  }
  title() {
    return '';
  }
  content() {
    let prevLine;
    if (this.newslines.length > 1) {
      prevLine = this.newslines[(this.line().index - 1 + this.newslines.length) % this.newslines.length];
    }
    return m("div", {
      className: "FoF-NewsWidget-content"
    }, m("div", {
      className: "FoF-NewsWidget-icon"
    }, m(Icon, {
      name: "fas fa-bullhorn"
    })), m("div", {
      className: "FoF-NewsWidget-line-container"
    }, this.newslines.map((line, index) => m("div", {
      className: classList(['FoF-NewsWidget-line', this.line().index === index ? 'FoF-NewsWidget-line--current' : '', prevLine === line ? 'FoF-NewsWidget-line--previous' : '']),
      key: index
    }, m.trust(line)))));
  }
}
flarum.reg.add('fof-news-widget', 'common/components/NewsWidget', NewsWidget);